meedy.controller('meedy.remindPasswordController', ['$scope', '$rootScope', '$state', '$stateParams', '$timeout', 'meedy.objectHelper', 'applicationModel', 'meedy.authModel', 'meedy.userModel', '$translate',
    function ($scope, $rootScope, $state, $stateParams, $timeout, objectHelper, applicationModel, authModel, userModel, $translate) {

        function setData() {
            $scope.remindPasswordData = {};

            $scope.forms = {
                remindPasswordForm: null
            };

            $scope.success = false;

        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
            });

            $scope.$on(Event.MEEDY.USER.REMIND_PASSWORD.SUCCESS, function (event, error) {
                $scope.success = true;
            });
        }

        function setActions() {

            $scope.remindPassword = function() {
                $scope.forms.remindPasswordForm.$setSubmitted();

                if ($scope.forms.remindPasswordForm.$valid) {
                    userModel.remindPassword($scope.remindPasswordData.email);
                }
            };

            $scope.goToLogin = function() {
                $state.go(Constant.STATE.PRE.MEEDY.LOGIN);
            };

        }

        function configureInterface() {
        }

        function initialize() {
            $timeout(function(){
                applicationModel.viewReady = true;
            },50);
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
